<template>
    <van-popup v-model:show="show" :style="{
        minWidth: '30%',
        minHeight: '5%',
        background: '#000000cc',
        borderRadius: '10px',
        color: '#fff',
        display: 'flex',
        padding: '10px 15px',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        zIndex: '10002'
    }" :overlay-style="props.transparentOverlay ? { background: 'transparent' } : {}">
        <van-loading v-if="props.isLoading && themeStore.themeIndex === 1" />
        <img class="loadingImage" v-if="props.isLoading && themeStore.themeIndex === 2"
            src="@/assets/theme/loading.webp" alt="" width="25%">
        <van-loading v-if="props.isLoading && themeStore.themeIndex === 3" type="spinner" />
        <van-icon name="success" size="40" v-if="props.isShowSuccess" />
        <van-icon name="fail" size="40" v-if="!props.isShowSuccess && !props.isLoading" />
        <div class="content"> {{ $t(props.content) }}</div>
    </van-popup>
</template>

<script setup lang="ts">
import { useThemeStore } from '@/stores/theme'
import { ref } from 'vue'

const themeStore = useThemeStore()
const show = ref(false)
const props = defineProps({
    content: {
        type: String,
        default: () => ''
    },
    isLoading: {
        type: Boolean,
        default: () => false
    },
    isShowSuccess: {
        type: Boolean,
        default: () => false
    },
    transparentOverlay: {
        type: Boolean,
        default: false
    }
})
const open = () => {
    show.value = true
    setTimeout(() => {
        show.value = false
    }, 1000)
}
defineExpose({
    open,
})

</script>
<style scoped>
.content {
    padding: 0 10px;
    font-size: 14px;
}

.van-overlay {
    background-color: #00000047
}

.loadingImage {
    padding: 20px;
    background-color: rgba(41, 33, 43, 0.695);
    border-radius: 15px;
}
</style>